/* eslint-disable no-unused-vars */

import xaxios from '@/xaxios';
import gql from 'graphql-tag';

const findModuloPortalName = async (thiz,nombre) => {
  const sql = gql`query{ getModulos(cursor:1000000,nombre:\"${nombre}\"){ id,nombre,sigla,tipo } }`;
  const fmods = await thiz.$apollo.query({ query: sql }).then(({data})=>data).catch((e)=>e);
  if(fmods && fmods.getModulos){
    if(fmods.getModulos.length>0) {
      const mod_portal = fmods.getModulos[0].nombre.toLowerCase()
      const modporguniv = nombre.toLowerCase();      
      if(mod_portal == modporguniv) return fmods.getModulos[0]
      else return {}
    }
  } 
  return {}
}

const createModuloPortal = async (thiz,nombre) => {
  const obj = {
    nombre: nombre,
    sigla: 'MOD-v2',
    tipo: 'NEW',
  }
  const sql = gql`mutation{ createModulo(input:${window.stringifyObject(obj)}){ok,modulo{id,nombre,sigla,tipo},errors{message}} }`;
  const mod = await thiz.$apollo.mutate({ mutation: sql }).then(({data})=>data).catch((e)=>e);
  if(mod && mod.createModulo){
    if(mod.createModulo.ok) return mod.createModulo.modulo
    else{
      window.console.log('errmod', mod);
      
      thiz.$root.$notify.show(mod.createModulo.errors[0].message, { color: 'red', x: 'right' });
      
    }
  }else{
    thiz.$root.$notify.show('error al crear modulo del programa universidad: '+nombre, { color: 'red', x: 'right' });
  }
  return {}
}

export const getModulosProgramaUniversidad = async (thiz,proguniv_id, programa) => {
    const urlmods = process.env.VUE_APP_URL_API_PAGOS2+'modulos-programas-universidades?programaUniversidadId='+proguniv_id;
    const resmods = await xaxios.get(urlmods).then(({data})=>data).catch((e)=>e);
    if(resmods && resmods.datos){
      const modulosunis = resmods.datos
      modulosunis.sort((a,b)=>a.numero - b.numero)

      programa.programa_modulo = []
      window.console.log('modulos_unis',modulosunis);

      // let nuerito = 0
      for(let i=0;i<modulosunis.length;i++){
        const m = modulosunis[i]; 

        let mod = await findModuloPortalName(thiz,m.nombre)
        if(!mod || !mod.id){
          // este registra pero no devuelve el modulo asi que por eso volvemos a buscar
          window.console.log('yaaaaa crear>>>',mod);
          
          await createModuloPortal(thiz,m.nombre)
          mod = await findModuloPortalName(thiz,m.nombre)
        }
        // window.console.log('modddddd', mod);
        
        if(!mod || !mod.id) continue;
        /* const ex = programa.programa_modulo.find(x=>x.modulo_id == mod.id)
        if(ex) continue; */

        const add = {
          modulo_id: mod.id,
          programa_modulo_id: null, //i +1
          // numero: nuerito++,
          numero: m.numero,
          tipo_calificacion: 'Moodle y Sistema',
          fecha_inicio: m.fechaInicio,
          fecha_fin: m.fechaFin,
          xmodulo: mod,
          modulo_programa_universidad_id: m.id,
        }  
        
        programa.programa_modulo.push( add );
      }
      // { "modulo_id": 11642, "programa_modulo_id": -1, "numero": "0", "tipo_calificacion": "Moodle y Sistema", "fecha_inicio": "2026-03-01", "fecha_fin": "2026-03-31" } 

      
      return modulosunis
    }
    return []
}

